import '../chart_view.js.coffee';# Added by Script 
import '../../../monitoring/charts/chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.AverageTimeChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/first_metrics/average_time_chart']

  events:
    'click #average-time': '_onClickAverageTime'
    'click #percentage-over': '_onClickPercentageOver'
    'click #percentage-under': '_onClickPercentageUnder'

  initialize: ({
    sla, compliesWithSlaCount, uncompliesWithSlaCount, averageTimeInSeconds, translations,
    clickable, dimension, metricNames, widgetName, currentData, options
  }) ->
    @sla = sla
    @compliesWithSlaCount = compliesWithSlaCount
    @uncompliesWithSlaCount = uncompliesWithSlaCount
    @analyzedTicketCount = @compliesWithSlaCount + @uncompliesWithSlaCount
    @averageTimeInSeconds = averageTimeInSeconds
    @translations = translations
    @clickable = clickable
    @dimension = dimension
    @metricNames = metricNames ? [dimension]
    @widgetName = widgetName
    super(options)
    @currentData = currentData || @data

  render: ->
    @$el.html @template({
      sla: @_formatSeconds(@sla),
      analyzedTicketCount: @_formatInt(@analyzedTicketCount),
      averageTime: @_formatSeconds(@averageTimeInSeconds),
      translations: @translations,
    })
    new Highcharts.Chart(@_highchartsOptions())
    negativeView = @_negativePercentageLabelView()
    positiveView = @_positivePercentageLabelView()
    @$el.find('.percentage-under-threshold').append(negativeView.render().el)
    @$el.find('.percentage-over-threshold').append(positiveView.render().el)
    if @clickable
      @$el.find('.percentage-under-threshold').addClass('clickable')
      @$el.find('.percentage-over-threshold').addClass('clickable')
      @$el.find('.average-time-container').addClass('clickable')
      @listenTo(@, 'average-time:click', @_openDrilldownAverage)
      @listenTo(@, 'percentage-over:click', @_openDrilldownOver)
      @listenTo(@, 'percentage-under:click', @_openDrilldownUnder)
    @

  _onClickAverageTime: ->
    return unless @clickable
    @trigger('average-time:click')

  _onClickPercentageOver: ->
    return unless @clickable
    @trigger('percentage-over:click')

  _onClickPercentageUnder: ->
    return unless @clickable
    @trigger('percentage-under:click')

  _executeDrilldown: (options = {}) ->
    title = @translations.drilldownTitle
    title = "#{title} / #{options.title_suffix}" if options.title_suffix
    drilldownOptions =
      range_metric_value: options.range_metric_value
      dimensions: [@dimension, 'range_metric_value']
      metric_names: @metricNames
      name: title
      drilldown_code: 'ticket_with_metrics_sla'
      timezone: moment().format('Z')
    @_openDrilldown(drilldownOptions)

  _openDrilldownAverage: ->
    @_executeDrilldown(@_addDateOptionsTo(range_metric_value: {metric: @dimension}))

  _openDrilldownOver: ->
    @_executeDrilldown(
      @_addDateOptionsTo(
        range_metric_value: {metric: @dimension, max_value: @sla}
        title_suffix: I18n.t('customer_visual_mode.charts.first_metrics.in_the') + ' ' +  @translations.sla
      )
    )

  _openDrilldownUnder: ->
    @_executeDrilldown(
      @_addDateOptionsTo(
        range_metric_value: {metric: @dimension, min_value: @sla}
        title_suffix: I18n.t('customer_visual_mode.charts.first_metrics.outside_the') + ' ' + @translations.sla
      )
    )

  _widgetName: ->
    @widgetName

  _addDateOptionsTo: (options) ->
    dateOptions = {}
    dateOptions['start_date'] = @currentData['start_trigger_date'] if @currentData['start_trigger_date']
    dateOptions['end_date'] = @currentData['end_trigger_date'] if @currentData['end_trigger_date']
    options['range_metric_value'] = _.extend(options['range_metric_value'], dateOptions)
    options

  _formatInt: (value) ->
    if !value
      0
    else
      value

  _formatSeconds: (secondsToFormat) ->
    duration = moment.duration(@_formatInt(parseInt(secondsToFormat, 10)), 'seconds')
    hours = parseInt(duration.asHours(), 10)
    minutes = parseInt(duration.minutes(), 10)
    seconds = parseInt(duration.seconds(), 10)
    "#{@_prependDigit(hours)}:#{@_prependDigit(minutes)}:#{@_prependDigit(seconds)}"

  _prependDigit: (number) ->
    "#{number}".padStart(2, '0')

  _negativePercentageLabelView: ->
    new CustomerVisualMode.Charts.PercentageLabelView({
      percentage: @_percentage(@uncompliesWithSlaCount)
      count: @uncompliesWithSlaCount,
      type: 'negative'
    })

  _positivePercentageLabelView: ->
    new CustomerVisualMode.Charts.PercentageLabelView({
      percentage: @_percentage(@compliesWithSlaCount)
      count: @compliesWithSlaCount,
      type: 'positive'
    })

  _clickChartCallback: ->
    that = @
    return (event) ->
      if (this.color == that._green())
        that._onClickPercentageOver()
      else if (this.color == that._red())
        that._onClickPercentageUnder()

  _highchartsOptions: ->
    {
      chart: {
        type: 'solidgauge',
        renderTo: @$el.find('.circle-chart')[0],
        height: 120,
        width: 120,
      },
      title: {text: ''},
      exporting: {enabled: false},
      tooltip: {enabled: false}
      pane: @_paneOptions(),
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: []
      },
      plotOptions: @_plotOptions(),
      series: [
        {
          borderColor: @_green(),
          data: [{
            color: if @analyzedTicketCount > 0 then @_red() else @_noDataColor(),
            radius: '105%',
            innerRadius: '85%',
            y: 100
          },{
            color: @_green(),
            radius: '105%',
            innerRadius: '85%',
            y: parseInt(@_percentage(@compliesWithSlaCount))
          }]
        }
      ]
    }

  _plotOptions: ->
    options = {
      solidgauge: {
        borderWidth: 0,
        dataLabels: {
          enabled: false
        },
        linecap: 'round',
        stickyTracking: false,
      }
    }

    if @analyzedTicketCount && @clickable
      _.extend(options,
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click: @_clickChartCallback()
            }
          }
        }
      )

    options

  _paneOptions: ->
    {
      center: ['50%', '50%'],
      startAngle: 0,
      endAngle: 360,
      size: '95%'
      background: [{
        borderWidth: 0
        radius: '100%',
        innerRadius: '85%'
      }]
    }

  _percentage: (count) ->
    return 0 unless @analyzedTicketCount
    ((count / @analyzedTicketCount) * 100).toFixed(2)

  _green: ->
    '#27ae60'

  _red: ->
    '#c0392b'

  _noDataColor: ->
    '#35444C'
